var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "peppol-endpoints-editor" },
    [
      _vm.endpoints.length === 0
        ? _c("div", { staticClass: "empty-state" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.fallbackVat
                    ? _vm.$ct("no-endpoints-vat-fallback", {
                        vat: _vm.fallbackVat,
                      })
                    : _vm.$ct("no-endpoints")
                ) +
                " "
            ),
          ])
        : _c(
            "div",
            { staticClass: "endpoints-list" },
            _vm._l(_vm.endpoints, function (endpoint, i) {
              return _c("div", { key: i, staticClass: "endpoint-item" }, [
                _c("div", { staticClass: "endpoint-info" }, [
                  _c("div", { staticClass: "endpoint-title" }, [
                    _c("span", { staticClass: "endpoint-label" }, [
                      _vm._v(
                        _vm._s(
                          endpoint.Label ||
                            endpoint.getFullID() ||
                            _vm.$ct("untitled-endpoint")
                        )
                      ),
                    ]),
                    endpoint.IsDefault
                      ? _c("span", { staticClass: "default-chip" }, [
                          _vm._v(_vm._s(_vm.$ct("default"))),
                        ])
                      : _vm._e(),
                  ]),
                  endpoint.Label && endpoint.getFullID()
                    ? _c("div", { staticClass: "endpoint-id" }, [
                        _vm._v(_vm._s(endpoint.getFullID())),
                      ])
                    : _vm._e(),
                ]),
                _c(
                  "div",
                  { staticClass: "endpoint-actions" },
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("edit"),
                            expression: "$ct('edit')",
                          },
                        ],
                        attrs: { flat: "" },
                        on: {
                          click: function ($event) {
                            return _vm.openEditModal(i)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "edit" } })],
                      1
                    ),
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("remove"),
                            expression: "$ct('remove')",
                          },
                        ],
                        staticClass: "danger",
                        attrs: { flat: "" },
                        on: {
                          click: function ($event) {
                            return _vm.removeEndpoint(i)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ])
            }),
            0
          ),
      _c(
        "div",
        { staticClass: "add-row" },
        [
          _c(
            "w-link",
            {
              on: {
                click: function ($event) {
                  return _vm.openAddModal()
                },
              },
            },
            [
              _c("w-fa", { attrs: { icon: "plus" } }),
              _vm._v(" " + _vm._s(_vm.$ct("add-endpoint")) + " "),
            ],
            1
          ),
        ],
        1
      ),
      _vm.modalOpen
        ? _c(
            "w-modal",
            {
              attrs: { "escape-close": "" },
              model: {
                value: _vm.modalOpen,
                callback: function ($$v) {
                  _vm.modalOpen = $$v
                },
                expression: "modalOpen",
              },
            },
            [
              _c(
                "w-card",
                { attrs: { "max-width": "500" } },
                [
                  _c("w-card-title", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.editingIndex === null
                            ? _vm.$ct("add-endpoint")
                            : _vm.$ct("edit-endpoint")
                        ) +
                        " "
                    ),
                  ]),
                  _c(
                    "w-card-content",
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: { label: _vm.$ct("label"), fancy: "" },
                                model: {
                                  value: _vm.draft.Label,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.draft, "Label", $$v)
                                  },
                                  expression: "draft.Label",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("app-peppol-endpoint-input", {
                                attrs: { value: _vm.draftFullID },
                                on: {
                                  input: function ($event) {
                                    return _vm.onDraftEndpointInput($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-checkbox", {
                                attrs: { label: _vm.$ct("is-default") },
                                model: {
                                  value: _vm.draft.IsDefault,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.draft, "IsDefault", $$v)
                                  },
                                  expression: "draft.IsDefault",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          staticClass: "cancel",
                          attrs: { icon: "ban" },
                          on: {
                            click: function ($event) {
                              return _vm.closeModal()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          staticClass: "confirm",
                          attrs: { disabled: !_vm.canSaveDraft, icon: "check" },
                          on: {
                            click: function ($event) {
                              return _vm.saveDraft()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("common.confirm")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }